export default __webpack_public_path__ + "static/media/mongo_logo.6e9578f3.webp";